import { render, staticRenderFns } from "./selected-site-service-request.vue?vue&type=template&id=6edf8f2c&scoped=true&"
import script from "./selected-site-service-request.vue?vue&type=script&lang=js&"
export * from "./selected-site-service-request.vue?vue&type=script&lang=js&"
import style0 from "./selected-site-service-request.vue?vue&type=style&index=0&id=6edf8f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edf8f2c",
  null
  
)

export default component.exports